import Swiper from "swiper";
import { Navigation, Pagination, Thumbs, Autoplay, Scrollbar, Controller, EffectFade, Manipulation } from "swiper/modules";
export default () => ({
	galleryThumbnail: null,
	galleryMain: null,
	variantSelectors:[],
	sliderInitialized: false,
	init() {
		this.imageGallery();
		this.variantSelectors = document.querySelectorAll('.variant-slider-js')
		this.scrollToSelectedVariantImage()

		this.variantSelectors.forEach(variantSelector => {
			variantSelector.addEventListener("click", ()=>{
				this.scrollToSelectedVariantImage()
			})
		});
	},
	imageGallery() {
		let gallery_thumbnail_swiper = this.$el.querySelector('.gallery-thumbnail');
		let gallery_main_swiper = this.$el.querySelector('.gallery-main');

		this.galleryThumbnail = new Swiper(gallery_thumbnail_swiper, {
			modules: [Navigation, Controller, Manipulation, Thumbs],
			...{
				spaceBetween: 16,
				slidesPerView: 4,
				freeMode: true,
				watchSlidesProgress: true,
				direction: "vertical",
				navigation: {
					nextEl: '[data-thumbs-arrow-next]',
					prevEl: '[data-thumbs-arrow-prev]',
				},
			}
		  });
		this.galleryMain = new Swiper(gallery_main_swiper, {
			modules: [Navigation, Pagination, Scrollbar, Controller, Thumbs],
			...{
				grabCursor: true,
				thumbs:{
					swiper: this.galleryThumbnail
				},
				scrollbar: {
					el: '.pg-swiper-scrollbar',
					draggable: true,
				},
				breakpoints: {
					0:{
						slidesPerView: 1,
					},
					990: {
						slidesPerView: 1,
					},
				},
				on: {
					transitionStart: function(){
					  var videos = document.querySelectorAll('.swiper-slide video');
					  Array.prototype.forEach.call(videos, function(video){
						video.pause();
					  });

					  var iframes = document.querySelectorAll('.swiper-slide iframe');
					  Array.prototype.forEach.call(iframes, function(iframe){
						iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
					  });

					},
					touchStart: function(swiper){
						let activeIndex = swiper.activeIndex;
						let activeSlide = document.querySelector(`.swiper-slide[data-slide-index="${activeIndex}"]`);
						if(activeSlide.classList.contains('swiper-video-slide')){
							let video = activeSlide.children[0].children[0];
							if(video.nodeName == 'IFRAME'){
								if(video.classList.contains('video-playing')){
									document.getElementById(video.id).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
									video.classList.remove('video-playing');
								}else{
									document.getElementById(video.id).contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
									video.classList.add('video-playing');
								}

							}
							if(video.nodeName == 'VIDEO'){
								if (video.paused) {
									video.play();
								} else {
									video.pause();
								}
							}
						}
					},
					slideChange: (event) => {
						let index_currentSlide = event.realIndex
						let currentSlide = event.slides[index_currentSlide]
						let videoContainer = currentSlide.querySelector(".video-container")
						if (videoContainer){
							const video = this.productContainer.querySelectorAll("video")

							if (!videoContainer && video.length) {
								video.forEach(vid => {
									vid.pause()
									vid.currentTime = 0
								})
							}
							currentSlide.click()
						}

					}
				},
				navigation: {
					nextEl: '.gallerythumb-arrow-next',
					prevEl: '.gallerythumb-arrow-prev',
				},

			}

		});
		this.sliderInitialized = true
	},
	scrollToSelectedVariantImage(){
		setTimeout(()=>{
			if (document.getElementById("js-image-id")){
				let ImageID = document.getElementById("js-image-id").value;
				let galleryImage = '.media-' + ImageID

				if (document.querySelector(galleryImage)){
					let slideIndex = document.querySelector(galleryImage).getAttribute('data-slide-index');
					this.galleryMain.slideTo(parseInt(slideIndex))
				}
			}
		}, 0)
	}
})
